import { React, classNames, withStyles, StyledProps } from '@api'

interface MyProps extends StyledProps {
}

export class AppBarTitle extends React.Component<MyProps> {
  render() {
    const {props: {children, className}} = this;
    return (
      <div className={className}>
        {children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/AppBarTitle.tsx